import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FaHome, FaInfoCircle, FaQuestionCircle  } from 'react-icons/fa';
import logo from '../Assets/Logo.png'; 
import dropDown from '../Assets/template/overview.png';


const SidebarGuest = ({ onSelect, selectedContent, onToggleSidebar  }) => {
const [isSidebarExpanded, setSidebarExpanded] = useState(false);
const sidebarRef = useRef();
const [isHomeHovered, setIsHomeHovered] = useState(false);
const [isAboutHovered, setIsAboutHovered] = useState(false);
const [isHelpHovered, setIsHelpHovered] = useState(false); 

useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        isSidebarExpanded
      ) {
        setSidebarExpanded(false);
        onToggleSidebar(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSidebarExpanded, onToggleSidebar]);


  const toggleSidebar = () => {
    const newState = !isSidebarExpanded;
    setSidebarExpanded(newState);
    onToggleSidebar(newState); 
  };

  return (
    <NavbarContainer ref={sidebarRef} isExpanded={isSidebarExpanded}>
      <HeaderSection>
        <LogoContainer>
          <LogoImage src={logo} alt="Logo" />
          {isSidebarExpanded && <LogoText>DISA</LogoText>}
        </LogoContainer>
        <HamburgerMenu onClick={toggleSidebar}>
          {isSidebarExpanded ? <VerticalHamburgerIcon /> : <HorizontalHamburgerIcon />}
        </HamburgerMenu>
      </HeaderSection>
      <Line />
      <NavLinks>
      <NavItem
  onClick={() => onSelect('HomeAdmin')}
  onMouseEnter={() => setIsHomeHovered(true)}
  onMouseLeave={() => setIsHomeHovered(false)}
>
  <NavIcon as={FaHome} />
  {isSidebarExpanded ? <NavText>Home</NavText> : isHomeHovered && <Tooltip>Home</Tooltip>}
</NavItem>


        <NavItem
           onClick={() => onSelect('AboutAdmin')}
           onMouseEnter={() => setIsAboutHovered(true)}
          onMouseLeave={() => setIsAboutHovered(false)}
        >
      <NavIcon as={FaInfoCircle} />
       {isSidebarExpanded ? <NavText>About</NavText> : isAboutHovered && <Tooltip>About</Tooltip>}
        </NavItem>

        <NavItem
          onClick={() => onSelect('HelpGuest')}
          onMouseEnter={() => setIsHelpHovered(true)}
          onMouseLeave={() => setIsHelpHovered(false)}
       >
          <NavIcon as={FaQuestionCircle} />
          {isSidebarExpanded ? <NavText>Help</NavText> : isHelpHovered && <Tooltip>Help</Tooltip>}
        </NavItem>
      </NavLinks>

    </NavbarContainer>
  );
};

export default SidebarGuest;

const NavbarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ isExpanded }) => (isExpanded ? 'flex-start' : 'center')};
  background-image: url(${require('../Assets/template/vmo.jpg')});
  background-size: cover;
  background-position: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${({ isExpanded }) => (isExpanded ? '180px' : '60px')};
  z-index: 1000;
  height: 100vh;
  padding-top: 5px;
  transition: width 0.3s ease;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg,rgb(13, 207, 55),rgb(13, 110, 9));
    z-index: -1;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
`;

const LogoImage = styled.img`
  width: 45px;
  height: 45px;
  object-fit: contain;

`;

const LogoText = styled.span`
  font-size: 13px;
  font-weight: bold;
  color: rgb(247, 241, 241);
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
`;

const HamburgerMenu = styled.div`
  cursor: pointer;
  marginTop: 30px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgb(241, 235, 235);
  margin: 5px 0;
`;

const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const NavItem = styled.button`
  display: flex;
  flex-direction: row; 
  align-items: center;
  background: transparent;
  color: rgb(222, 226, 224);
  font-size: 19px;
  border: none;
  cursor: pointer;
  padding: 10px;
  width: 95%;
  justify-content: ${({ isSidebarExpanded }) => (isSidebarExpanded ? 'flex-start' : 'flex-start')}; /* Align text based on sidebar state */
  &:hover {
    color: rgb(68, 143, 75);
  }
`;

const NavIcon = styled.div`
 font-size: ${({ isExpanded }) => (isExpanded ? '18px' : '18px')};
  color: #f8fcfa;
  margin-right: 15px; 
`;



const NavText = styled.span`
  font-size: 17px;
  color: #f8fcfa;
  margin-left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '10px' : '0')}; 
`;


const Tooltip = styled.span`
  position: absolute;
  left: 30px; /* Adjust based on icon size */
   background-image: linear-gradient(rgba(78, 151, 78, 0.5), rgba(0, 0, 0, 0.5)), url(${dropDown});
  color: white;
  padding: 5px 5px;
  border-radius: 2px;
  font-size: 12px;
  white-space: nowrap;
  transition: opacity 0.3s ease-in-out;
  opacity: 0.9;
  z-index: 1000;
`;

const HorizontalHamburgerIcon = () => (
  <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
    <div style={{ width: '2px', height: '16px', marginTop: '10px', backgroundColor: '#f8fcfa' }}></div>
   
    <div style={{ width: '2px', height: '16px', marginTop: '10px', backgroundColor: '#f8fcfa' }}></div>
  </div>
);


const VerticalHamburgerIcon = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '18px', height: '15px',  marginTop: '10px' }}>
    <div style={{ height: '2px', backgroundColor: '#f8fcfa', width: '100%' }}></div>
   
    <div style={{ height: '2px', backgroundColor: '#f8fcfa', width: '100%' }}></div>
  </div>
);
